

const expandHex = require('./expand');

module.exports = (hex) => {

  hex = parseInt(expandHex(hex.replace('#', '')), 16);
  return {
    'red': hex >> 16,
    'green': (hex >> 8) & 0x00FF,
    'blue': hex & 0x0000FF
  };
};



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/toRgb.js